


export default {
	pages : {},
	films : {
		posterID : null,
		videoID : null
	},
	credits : null
}



// WEBPACK FOOTER //
// ./src/app-store.js